class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
  }

  onSummaryClick(e) {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
    if (!submenu) return;
    e.preventDefault();
    if (submenu.classList.contains('submenu-closing')) return;
    submenu.classList.add('submenu-closing');
    submenu.addEventListener('animationend', () => {
      submenu.classList.remove('submenu-closing');
      this.close();
    }, { once: true });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      const nav = this.header.querySelector('.header__inline-menu');
      const bottom = nav
        ? Math.floor(nav.getBoundingClientRect().bottom)
        : Math.floor(this.header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--header-bottom-position-desktop', `${bottom}px`);

      const summary = this.mainDetailsToggle.querySelector('summary');
      const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
      if (summary && submenu) {
        submenu.style.paddingLeft = `${Math.floor(summary.getBoundingClientRect().left)}px`;
      }
    }
  }
}

customElements.define('header-menu', HeaderMenu);
